import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export type PublicWebMediaPolicy = {
  maxHeroImageBytes: number;
  maxThemeImageBytes: number;
  maxStaffPhotoBytes: number;
  maxNewsletterPdfBytes: number;
  maxPublicVideoBytes: number;
};

export const DEFAULT_PUBLIC_WEB_MEDIA_POLICY: PublicWebMediaPolicy = {
  maxHeroImageBytes: 15 * 1024 * 1024,
  maxThemeImageBytes: 10 * 1024 * 1024,
  maxStaffPhotoBytes: 5 * 1024 * 1024,
  maxNewsletterPdfBytes: 15 * 1024 * 1024,
  maxPublicVideoBytes: 250 * 1024 * 1024,
};

const HARD_LIMITS: PublicWebMediaPolicy = {
  maxHeroImageBytes: 25 * 1024 * 1024,
  maxThemeImageBytes: 10 * 1024 * 1024,
  maxStaffPhotoBytes: 5 * 1024 * 1024,
  maxNewsletterPdfBytes: 25 * 1024 * 1024,
  maxPublicVideoBytes: 250 * 1024 * 1024,
};

function readBytes(value: unknown, fallback: number, hardMax: number) {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.max(256 * 1024, Math.min(hardMax, Math.round(n)));
}

export function formatBytesMb(bytes: number) {
  return `${(bytes / 1024 / 1024).toFixed(bytes % (1024 * 1024) === 0 ? 0 : 1)} MB`;
}

export function normalizePublicWebMediaPolicy(data: unknown): PublicWebMediaPolicy {
  const d = (data || {}) as Partial<PublicWebMediaPolicy>;
  return {
    maxHeroImageBytes: readBytes(d.maxHeroImageBytes, DEFAULT_PUBLIC_WEB_MEDIA_POLICY.maxHeroImageBytes, HARD_LIMITS.maxHeroImageBytes),
    maxThemeImageBytes: readBytes(d.maxThemeImageBytes, DEFAULT_PUBLIC_WEB_MEDIA_POLICY.maxThemeImageBytes, HARD_LIMITS.maxThemeImageBytes),
    maxStaffPhotoBytes: readBytes(d.maxStaffPhotoBytes, DEFAULT_PUBLIC_WEB_MEDIA_POLICY.maxStaffPhotoBytes, HARD_LIMITS.maxStaffPhotoBytes),
    maxNewsletterPdfBytes: readBytes(d.maxNewsletterPdfBytes, DEFAULT_PUBLIC_WEB_MEDIA_POLICY.maxNewsletterPdfBytes, HARD_LIMITS.maxNewsletterPdfBytes),
    maxPublicVideoBytes: readBytes(d.maxPublicVideoBytes, DEFAULT_PUBLIC_WEB_MEDIA_POLICY.maxPublicVideoBytes, HARD_LIMITS.maxPublicVideoBytes),
  };
}

export async function loadPublicWebMediaPolicy() {
  try {
    const snap = await getDoc(doc(db, "settings", "publicWebMediaPolicy"));
    return normalizePublicWebMediaPolicy(snap.exists() ? snap.data() : {});
  } catch {
    return DEFAULT_PUBLIC_WEB_MEDIA_POLICY;
  }
}
